import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Margin from "Components/Stats/Margin";
import { getStudentsByProfileData } from "Components/Stats/Data/Utilisateurs/Etudiants";
import NivoPie from "Components/Stats/Charts/NivoPie";

const UsersByProfile = (props) => {
  const [usersByProfile, setUsersByProfile] = useState([]);

  useEffect(() => {
    setUsersByProfile(getStudentsByProfileData());
  }, []);

  return (
    <React.Fragment>
      <NivoPie
        data={usersByProfile}
        title={
          "Répartition des utilisateurs par profil sur l'université " +
          props.universityName
        }
        colors={"pastel1"}
        displayPercentage
      />
      <Margin position="bottom" size="" />
    </React.Fragment>
  );
};

UsersByProfile.propTypes = {
  universityName: PropTypes.string,
};

export default UsersByProfile;
